export const getSearchQuery = ({ search }) => search.searchInput;

export const getSearchDebounceId = ({ search }) => search.debounceId;

export const getSearchedHistory = ({ search }) => search.searchHistory;

export const getDefaultResults = ({ search }) => search.defaultResults;
